export const getUnitLabel = (isSquareFeet) => (isSquareFeet ? "Square Feet" : "Flat");

export const formatProjectUnit = (isSquareFeet, value) => `${getUnitLabel(isSquareFeet)}: ${value}`;

export const formatUnitAmount = (isSquareFeet, value) => `${value} ${getUnitLabel(isSquareFeet)}`;

export const getTotalUnitLabel = (isSquareFeet) =>
  isSquareFeet ? "Total Square Feet" : "Total Flat";

export const getBuyingUnitLabel = (isSquareFeet) =>
  isSquareFeet ? "Square feet area" : "Number of buying flat";

export const getSellUnitLabel = (isSquareFeet) =>
  isSquareFeet ? "Square feet to sell" : "Number of flat to sell";
